import { Box } from "@mui/material";
import ServeurErrorIcon from "../../../asset/images/ServeurErrorIcon";
import PTButton from "./PTButton";

function PTServeurErrorPage(props) {
  const { onRetour } = props;
  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <ServeurErrorIcon />
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <PTButton
          title="retour"
          variant="outlined"
          onClick={() => {
            if (onRetour) onRetour();
          }}
        />
      </Box>
    </Box>
  );
}

export default PTServeurErrorPage;
